(() => {
  if (window.__P80_CART_DRAWER_SYNC__) return;
  window.__P80_CART_DRAWER_SYNC__ = true;

  /* ===============================
     CHECKOUT GATE (SINGLE SOURCE)
  =============================== */
function applyCheckoutGate(root = document) {
  const checkboxes = root.querySelectorAll('.cart-agreement__checkbox');

  checkboxes.forEach(checkbox => {
    const container =
      checkbox.closest('.cart__ctas') ||
      checkbox.closest('.cart-footer') ||
      checkbox.closest('.cart__footer') ||
      checkbox.closest('.drawer__footer');

    if (!container) return;

    const checkoutBtn = container.querySelector('button[name="checkout"]');
    if (!checkoutBtn) return;

    const update = () => {
      const scopedCheckboxes =
        container.querySelectorAll('.cart-agreement__checkbox');

      const allChecked = [...scopedCheckboxes].every(cb => cb.checked);
      checkoutBtn.disabled = !allChecked;
    };

    update();

    if (!checkbox.dataset.p80Bound) {
      checkbox.dataset.p80Bound = 'true';
      checkbox.addEventListener('change', update);
    }
  });
}



  /* ===============================
     APPLY ON INITIAL LOAD
  =============================== */
    document.addEventListener('DOMContentLoaded', () => {
        applyCheckoutGate(document);
    });

  /* ===============================
     FETCH INTERCEPT (ADD TO CART)
  =============================== */
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    try {
      const url = args[0]?.toString?.() || '';
      if (!url.includes('/cart/add')) return response;

      setTimeout(async () => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        const wasOpen = drawer.hasAttribute('open');

        //  fetch authoritative drawer HTML
        const html = await fetch(
          `${routes.cart_url}?section_id=cart-drawer`
        ).then(r => r.text());

        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newItems  = doc.querySelector('cart-drawer-items');
        const newFooter = doc.querySelector('.cart-drawer__footer');

        const oldItems  = drawer.querySelector('cart-drawer-items');
        const oldFooter = drawer.querySelector('.cart-drawer__footer');

        if (newItems && oldItems) oldItems.replaceWith(newItems);
        if (newFooter && oldFooter) oldFooter.replaceWith(newFooter);

        // fix empty state lies
        drawer.classList.remove('is-empty');
        drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');

        // open only if it was closed
        if (!wasOpen) drawer.open();

        // RE-APPLY CHECKOUT GATE AFTER DOM REPLACEMENT
        applyCheckoutGate(drawer);

      }, 350);

    } catch (err) {
      console.error('[P80 CART DRAWER SYNC]', err);
    }

    return response;
  };

  /* ===============================
     DOM SAFETY NET
     (drawer replaced, reopened, etc)
  =============================== */
  const observer = new MutationObserver(() => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) applyCheckoutGate(drawer);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

})();
